import { render, staticRenderFns } from "./ViewTemplateConfiguration.vue?vue&type=template&id=841a1316&"
import script from "./ViewTemplateConfiguration.vue?vue&type=script&lang=js&"
export * from "./ViewTemplateConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports